export default __webpack_public_path__ + "static/media/Swirl.4c1b43da.svg";